import { Language } from './../objects/language';
// Types
import { List } from '../objects/list';
import { Circuit, CircuitRealStock, CircuitType } from '../objects/circuit';
import { IataCountry } from '../../iata/objects/iataCountry';
import { Preferences } from '../../profile/objects/preferences';
import { DestinationReduced } from '../../destination/objects/destinationReduced';
import { CircuitCategory } from '../../circuitCategory/objects/circuitCategory';
import { Cms } from '../../cms/objects/cms';
// Action Types
import {
    ADD_PREFERENCES,
    CircuitActionTypes,
    DELETE_CIRCUIT_PICTURE,
    DELETE_CIRCUIT_PRICE,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_ADD_CIRCUIT,
    RESET_FILTERS,
    SET_ACCOMODATION,
    SET_BO_ACCOMODATION,
    SET_ALLOWED_BO_ACCOMODATION,
    SET_CAR,
    SET_CIRCUIT,
    SET_CIRCUIT_PRICES,
    SET_CUSTOM_PRODUCTS,
    SET_EDIT,
    SET_EDIT_STEP,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_FLIGHT,
    SET_LIMIT,
    SET_LIST,
    SET_MANUAL_PRODUCTS,
    SET_TRAINS,
    SET_MASTER_PRICE,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES,
    SET_PRICES_FLIGHT,
    SET_PRICES_TERRESTRIAL,
    SET_PRODUCT_PERIOD,
    SET_RUNNING,
    SET_SEARCH,
    SET_TRANSFERS,
    TOGGLE_CANCEL_MODAL,
    TOGGLE_CIRCUIT_PICTURES_ORDER,
    TOGGLE_COLUMN,
    TOGGLE_CONTRACT_CREATE,
    TOGGLE_CREATE,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_CATEGORIES,
    UPDATE_CIRCUIT_NAME_LOCALE,
    UPDATE_CIRCUIT_PICTURE_ORDER,
    UPDATE_CONTRACT,
    UPDATE_CONTRACT_SELECTED,
    UPDATE_DESTINATION,
    UPDATE_DURATION_DAYS,
    UPDATE_DURATION_NIGHTS,
    UPDATE_FILTER_COUNTRY,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_DESTINATION,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_REFERENCE,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_STATUS,
    UPDATE_FILTER_TYPE,
    UPDATE_LIST_ITEM_VISIBILITY,
    UPDATE_LIST_ITEM_PROTECTED_DESCRIPTION,
    UPDATE_PERIOD_START_DATE,
    UPDATE_PERIOD_END_DATE,
    UPDATE_PRICE_TYPE,
    UPDATE_PROVIDER,
    UPDATE_REFERENCE,
    UPDATE_TRANSPORT_IN_ARRIVAL_DATE,
    UPDATE_EXTERNAL_REFERENCE,
    UPDATE_DISPLAY_FOR_PACKAGE,
    UPDATE_RETURN_FLIGHT,
    UPDATE_FLIGHT_PROPOSED,
    UPDATE_FLIGHT_PRICE_INDICATIVE,
    UPDATE_SALE_PITCH_LOCALE,
    UPDATE_PERIOD_DAYS,
    UPDATE_TYPE,
    DELETE_CIRCUIT_PERIOD,
    SET_DUPLICATE_CIRCUIT,
    ADD_CIRCUIT_PERIOD,
    UPDATE_TRIP,
    UPDATE_FILTER_CATEGORIES,
    UPDATE_FILTER_CMS,
    UPDATE_PRODUCTS,
    UPDATE_PRODUCTS_STACK,
    UPDATE_PRODUCTS_REFERENCE_PRODUCT_TO_REPLACE,
    UPDATE_CIRCUIT_NAME_LOCALES,
    UPDATE_FILTER_PROVIDERS,
    UPDATE_FILTER_SOURCE,
    UPDATE_SELECTED_CIRCUIT,
    UPDATE_MANY_CIRCUIT_VISIBILITY,
    UPDATE_FILTER_LANGUAGES,
    SET_COLUMNS,
    SET_IS_PROTECTED_DESCRIPTION,
    UPDATE_DISPLAY_FOR_TRIP_PLAN,
    TOGGLE_CIRCUIT_BANNERS_ORDER,
    UPDATE_EDIT_STOCK_STATE,
    UPDATE_CIRCUIT_REAL_STOCK,
    UPDATE_CIRCUIT_REAL_STOCKS,
    UPDATE_NB_OF_ISLANDS_INCLUDED,
    UPDATE_FILTER_NB_OF_ISLAND_INCLUDED,
    SET_EDIT_CMS,
    UPDATE_FILTER_PACKAGE_TYPES,
    UPDATE_FILTER_IS_PROTECTED_DESCRIPTION
} from './actionTypes';
import { CustomProvider } from "../../customProvider/objects/customProvider";
import { Contract } from "../../customProvider/objects/contract";
import { Error } from "../../manualAccommodation/objects/error";
import { CircuitPrices } from "../objects/circuitPrices";
import { Trip } from '../../trip/objects/trip';
import { CircuitState } from '../objects/circuitState';
import { ReducedLightDestination } from '../objects/reducedLightDestination';
import { Column } from '../objects/column';
import { CircuitCreateStepperDataPackageType } from '../circuitCreateStepper';
import { AccomodationBo } from '../objects/accomodationBo';
import { AllowedAccomodationBo } from '../objects/accomodationBo';


export const updateCircuitRealStock = (real_stock: CircuitRealStock): CircuitActionTypes => ({
    type: UPDATE_CIRCUIT_REAL_STOCK,
    payload: real_stock
});
export const updateCircuitRealStocks = (real_stocks: CircuitRealStock[]): CircuitActionTypes => ({
    type: UPDATE_CIRCUIT_REAL_STOCKS,
    payload: real_stocks
});
export const addPreferences = (preferences: Preferences[]): CircuitActionTypes => ({
    type: ADD_PREFERENCES,
    payload: preferences
});
export const updateEditStock = (is_open: boolean): CircuitActionTypes => ({
    type: UPDATE_EDIT_STOCK_STATE,
    payload: is_open
});

export const addCircuitPeriod = (price_index: number): CircuitActionTypes => ({
    type: ADD_CIRCUIT_PERIOD,
    payload: price_index
});
export const moveDownColumn = (index: number): CircuitActionTypes => ({
    type: MOVE_DOWN_COLUMN,
    payload: index
});

export const moveUpColumn = (index: number): CircuitActionTypes => ({
    type: MOVE_UP_COLUMN,
    payload: index
});
export const updateProvider = (provider: null | CustomProvider): CircuitActionTypes => ({
    type: UPDATE_PROVIDER,
    payload: provider
});
export const updateContract = (contract: null | Contract): CircuitActionTypes => ({
    type: UPDATE_CONTRACT,
    payload: contract
});

export const resetFilters = (): CircuitActionTypes => ({
    type: RESET_FILTERS
});

export const setCircuit = (circuit: Circuit | null, current_locale: number): CircuitActionTypes => ({
    type: SET_CIRCUIT,
    payload: { circuit, current_locale }
});

export const setAccomodation = (accomodateData : []): CircuitActionTypes => ({
    type: SET_ACCOMODATION,
    payload: accomodateData
});
export const setBoAccommodation = (accomodateData : AccomodationBo[]): CircuitActionTypes => ({
    type: SET_BO_ACCOMODATION,
    payload: accomodateData
});
export const setAllowedBoAccommodation = (accomodateData : AllowedAccomodationBo[]): CircuitActionTypes => ({
    type: SET_ALLOWED_BO_ACCOMODATION,
    payload: accomodateData
});
export const updatePriceType = (price_type: true | false): CircuitActionTypes => ({
    type: UPDATE_PRICE_TYPE,
    payload: price_type
});
export const updateReturnFlight = (return_flight: true | false): CircuitActionTypes => ({
    type: UPDATE_RETURN_FLIGHT,
    payload: return_flight
});
export const updateFlightProposed = (flight_proposed: true | false): CircuitActionTypes => ({
    type: UPDATE_FLIGHT_PROPOSED,
    payload: flight_proposed
});
export const updateFlightPriceIndicative = (flight_price_indicative: true | false): CircuitActionTypes => ({
    type: UPDATE_FLIGHT_PRICE_INDICATIVE,
    payload: flight_price_indicative
});
export const setManualProducts = (manualData : Array<any>): CircuitActionTypes => ({
    type: SET_MANUAL_PRODUCTS,
    payload: manualData
});
export const setTrains = (trainData : Array<any>): CircuitActionTypes => ({
    type: SET_TRAINS,
    payload: trainData
});

export const setCircuitPrices = (price: CircuitPrices | false): CircuitActionTypes => ({
    type: SET_CIRCUIT_PRICES,
    payload: price
});
export const setCustomProducts = (customData : Array<never>): CircuitActionTypes => ({
    type: SET_CUSTOM_PRODUCTS,
    payload: customData
});

export const setMasterPrice = (price : Array<any> | false): CircuitActionTypes => ({
    type: SET_MASTER_PRICE,
    payload: price
});

export const setCar = (carData : Array<never>): CircuitActionTypes => ({
    type: SET_CAR,
    payload: carData
});

export const setFlight = (flightData : Array<never>): CircuitActionTypes => ({
    type: SET_FLIGHT,
    payload: flightData
});

export const setTransfers = (transfersData : Array<never>): CircuitActionTypes => ({
    type: SET_TRANSFERS,
    payload: transfersData
});

export const setProductPeriod = (product : Array<never>): CircuitActionTypes => ({
    type: SET_PRODUCT_PERIOD,
    payload: product
});

export const updateCircuitProducts = (ids: number[], lock: boolean): CircuitActionTypes => ({
    type: UPDATE_PRODUCTS,
    payload: {
        ids,
        lock
    }
});


export const updateCircuitProductsStack = (ids: number[], is_stack_price: boolean): CircuitActionTypes => ({
    type: UPDATE_PRODUCTS_STACK,
    payload: {
        ids,
        is_stack_price
    }
});
export const updateCircuitProductsReferenceProductToReplace = (ids: number[], is_reference_product_to_replace: boolean): CircuitActionTypes => ({
    type: UPDATE_PRODUCTS_REFERENCE_PRODUCT_TO_REPLACE,
    payload: {
        ids,
        is_reference_product_to_replace
    }
});

export const updateCircuitPeriodStartDate = (date: null | Date, price_index: number, period_index: number): CircuitActionTypes => ({
    type: UPDATE_PERIOD_START_DATE,
    payload: {
        value: date,
        price_index: price_index,
        period_index: period_index
    }
});

export const updateCircuitPeriodEndDate = (date: null | Date, price_index: number, period_index: number): CircuitActionTypes => ({
    type: UPDATE_PERIOD_END_DATE,
    payload: {
        value: date,
        price_index: price_index,
        period_index: period_index
    }
});

export const updateCircuitPeriodDays = (days: number, price_index: number, period_index: number): CircuitActionTypes => ({
    type: UPDATE_PERIOD_DAYS,
    payload: {
        value: days,
        price_index: price_index,
        period_index: period_index
    }
});

export const deleteCircuitPeriod = (price_index: number, period_index: number): CircuitActionTypes => ({
    type: DELETE_CIRCUIT_PERIOD,
    payload: {
        price_index: price_index,
        period_index: period_index
    }
});
export const setDuplicateCircuit = (circuit: Circuit | null): CircuitActionTypes => ({
    type: SET_DUPLICATE_CIRCUIT,
    payload: circuit
});


export const deleteCircuitPrice = (index: number): CircuitActionTypes => ({
    type: DELETE_CIRCUIT_PRICE,
    payload: index
});

export const setPricesFlight = (flightData : Array<never>): CircuitActionTypes => ({
    type: SET_PRICES_FLIGHT,
    payload: flightData
});

export const setPricesTerrestrial = (terrestrial : Array<never>): CircuitActionTypes => ({
    type: SET_PRICES_TERRESTRIAL,
    payload: terrestrial
});

export const setEditStep = (
    step: 'INFO' |
        'VERSION_AND_VARIANT' |
        'SALE_PITCH' |
        'CONTRACTS' |
        'ITINERARY' |
        'PRICES' |
        'PRICES_AUTO' |
        'PRICES_TABLE_DATES' |
        'PRODUCTS' |
        'PRODUCTS_INCLUDED' |
        'CONTRACT_PARAMETERS' |
        'DEPARTURE_AIRPORT' |
        'DISCOUNTS_SUPPLEMENTS' |
        'NIGHTS' |
        'PRICES-INFO' |
        'FLIGHT_PARAMETER_INFO' |
        'CANCELATION_RULES' |
        'OFFERS' |
        'STOCK' |
        'MARKET' |
        'PARAMETERS' |
        'ROOMING_LIST' |
        'ALLOWED_PROVIDERS' |
        'INCLUDED_IN_PRICE' |
        'RECALCULATION_RULES' |
        'ROOMS' |
        'MEAL_PLAN' |
        'MEAL_PLAN_PRICE' |
        'CMS' |
        'SPECIAL_OFFER' |
        'PRODUCTS_REMPLACEMENT' |
        'SALES_AND_STOCK' |
        'ROOM_ORGANISATION' |
        'OFFLINE_FLIGHTS' |
        'BLACKOUT' |
        'MARGIN' |
        'PRODUCT_PARAMETERS'
): CircuitActionTypes => ({
    type: SET_EDIT_STEP,
    payload: step
});
export const setEditCms = (
    step: 'INFO' |
        'ALLOWED_CMS' |
        'OPTIONS' |
        'PROCESS'
): CircuitActionTypes => ({
    type: SET_EDIT_CMS,
    payload: step
});

export const setExportType = (type: 'CSV' | 'PDF'): CircuitActionTypes => ({
    type: SET_EXPORT_TYPE,
    payload: type
});

export const setLimit = (limit: number): CircuitActionTypes => ({
    type: SET_LIMIT,
    payload: limit
});

export const setList = (list: List): CircuitActionTypes => ({
    type: SET_LIST,
    payload: list
});

export const setOrderBy = (order_by: string): CircuitActionTypes => ({
    type: SET_ORDER_BY,
    payload: order_by
});

export const setPage = (page: number): CircuitActionTypes => ({
    type: SET_PAGE,
    payload: page
});

export const setPreferences = (preferences: Preferences[]): CircuitActionTypes => ({
    type: SET_PREFERENCES,
    payload: preferences
});

export const setRunning = (running: boolean): CircuitActionTypes => ({
    type: SET_RUNNING,
    payload: running
});
export const toggleContractCreate = (): CircuitActionTypes => ({
    type: TOGGLE_CONTRACT_CREATE
});
export const setSearch = (search: string): CircuitActionTypes => ({
    type: SET_SEARCH,
    payload: search
});

export const toggleColumn = (index: number): CircuitActionTypes => ({
    type: TOGGLE_COLUMN,
    payload: index
});

export const toggleCreate = (): CircuitActionTypes => ({
    type: TOGGLE_CREATE
});

export const toggleCancelModal = (): CircuitActionTypes => ({
    type: TOGGLE_CANCEL_MODAL
});

export const toggleExport = (active: boolean): CircuitActionTypes => ({
    type: TOGGLE_EXPORT,
    payload: active
});

export const toggleExportFull = (): CircuitActionTypes => ({
    type: TOGGLE_EXPORT_FULL,
});

export const toggleFilters = (): CircuitActionTypes => ({
    type: TOGGLE_FILTERS
});

export const toggleRefresh = (): CircuitActionTypes => ({
    type: TOGGLE_REFRESH
});

export const updateFilterCategories = (categories: null | CircuitCategory[]): CircuitActionTypes => ({
    type: UPDATE_FILTER_CATEGORIES,
    payload: categories
});

export const updateFilterCms = (cms: Cms[]): CircuitActionTypes => ({
    type: UPDATE_FILTER_CMS,
    payload: cms
});

export const updateFilterCountry = (country: null | IataCountry): CircuitActionTypes => ({
    type: UPDATE_FILTER_COUNTRY,
    payload: country
});

export const updateFilterCreatedDateGte = (date: Date | null): CircuitActionTypes => ({
    type: UPDATE_FILTER_CREATED_DATE_GTE,
    payload: date
});

export const updateFilterCreatedDateLte = (date: Date | null): CircuitActionTypes => ({
    type: UPDATE_FILTER_CREATED_DATE_LTE,
    payload: date
});

export const updateFilterCreator = (creator: string): CircuitActionTypes => ({
    type: UPDATE_FILTER_CREATOR,
    payload: creator
});

export const updateFilterDestination = (destination: null | ReducedLightDestination): CircuitActionTypes => ({
    type: UPDATE_FILTER_DESTINATION,
    payload: destination
});

export const updateFilterProviders = (providers: CustomProvider[]): CircuitActionTypes => ({
    type: UPDATE_FILTER_PROVIDERS,
    payload: providers
});

export const updateFilterSource = (sources: ("TRAVEL_EXCHANGE" | "OFFLINE" | "GESTOUR" | "ADALTE" | "KOOB")[]): CircuitActionTypes => ({
    type: UPDATE_FILTER_SOURCE,
    payload: sources
});

export const updateFilterLastAuthor = (last_author: string): CircuitActionTypes => ({
    type: UPDATE_FILTER_LAST_AUTHOR,
    payload: last_author
});

export const updateFilterReference = (reference: string): CircuitActionTypes => ({
    type: UPDATE_FILTER_REFERENCE,
    payload: reference
});
export const updateFilterNbOfIslandsIncluded = (island: string | number): CircuitActionTypes => ({
    type: UPDATE_FILTER_NB_OF_ISLAND_INCLUDED,
    payload: island
});

export const updateFilterModifiedDateGte = (date: Date | null): CircuitActionTypes => ({
    type: UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: date
});

export const updateFilterModifiedDateLte = (date: Date | null): CircuitActionTypes => ({
    type: UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: date
});

export const updateFilterPeriod = (period: 'CREATION' | 'MODIFICATION'): CircuitActionTypes => ({
    type: UPDATE_FILTER_PERIOD,
    payload: period
});

export const updateFilterPeriodType = (type: number): CircuitActionTypes => ({
    type: UPDATE_FILTER_PERIOD_TYPE,
    payload: type
});

export const updateFilterStatus = (status: 'ALL' | 'OFFLINE' | 'ONLINE_TO' | 'ONLINE_AGENCY'): CircuitActionTypes => ({
    type: UPDATE_FILTER_STATUS,
    payload: status
});

export const updateFilterType = (status: 'ALL' | CircuitType): CircuitActionTypes => ({
    type: UPDATE_FILTER_TYPE,
    payload: status
});

export const updateFilterPackageTypes = (package_types: CircuitCreateStepperDataPackageType[]): CircuitActionTypes => ({
    type: UPDATE_FILTER_PACKAGE_TYPES,
    payload: package_types
});

export const updateFilterIsProtectedDescription = (is_protected_description: boolean | undefined): CircuitActionTypes => ({
    type: UPDATE_FILTER_IS_PROTECTED_DESCRIPTION,
    payload: is_protected_description
});

export const updateListItemVisibility = (item: Circuit): CircuitActionTypes => ({
    type: UPDATE_LIST_ITEM_VISIBILITY,
    payload: item
});

export const updateListItemProtectedDescription = (item: Circuit): CircuitActionTypes => ({
    type: UPDATE_LIST_ITEM_PROTECTED_DESCRIPTION,
    payload: item
});

export const resetAddCircuit = (): CircuitActionTypes => ({
    type: RESET_ADD_CIRCUIT
});

export const updateCircuitNameLocale = (id: number, value: string): CircuitActionTypes => ({
    type: UPDATE_CIRCUIT_NAME_LOCALE,
    payload: {
        id: id,
        value: value
    }
});

export const updateCircuitNameLocales = (locales: CircuitState['circuit_name_locales']): CircuitActionTypes => ({
    type: UPDATE_CIRCUIT_NAME_LOCALES,
    payload: locales
});

export const updateDurationDays = (days: number): CircuitActionTypes => ({
    type: UPDATE_DURATION_DAYS,
    payload: days
});

export const updateDurationNights = (nights: number): CircuitActionTypes => ({
    type: UPDATE_DURATION_NIGHTS,
    payload: nights
});
export const updateNbOfIslandsIncluded = (nb: number | string): CircuitActionTypes => ({
    type: UPDATE_NB_OF_ISLANDS_INCLUDED,
    payload: nb
});

export const updateDestination = (destination: DestinationReduced | null): CircuitActionTypes => ({
    type: UPDATE_DESTINATION,
    payload: destination
});

export const updateTrip = (trip: Trip): CircuitActionTypes => ({
    type: UPDATE_TRIP,
    payload: trip
});

export const updateType = (type: string): CircuitActionTypes => ({
    type: UPDATE_TYPE,
    payload: type
});

export const updateReference = (value: string): CircuitActionTypes => ({
    type: UPDATE_REFERENCE,
    payload: value
});
export const updateTransportInArrivalDate = (value: boolean): CircuitActionTypes => ({
    type: UPDATE_TRANSPORT_IN_ARRIVAL_DATE,
    payload: value
});

export const updateExternalReference = (value: string): CircuitActionTypes => ({
    type: UPDATE_EXTERNAL_REFERENCE,
    payload: value
});

export const updateDisplayForPackage = (value: boolean): CircuitActionTypes => ({
    type: UPDATE_DISPLAY_FOR_PACKAGE,
    payload: value
});

export const updateDisplayForTripPlan = (value: boolean): CircuitActionTypes => ({
    type: UPDATE_DISPLAY_FOR_TRIP_PLAN,
    payload: value
});

export const updateCategories = (categories: null | CircuitCategory[]): CircuitActionTypes => ({
    type: UPDATE_CATEGORIES,
    payload: categories
});

export const updateSalePitchLocale = (id: number, value: string): CircuitActionTypes => ({
    type: UPDATE_SALE_PITCH_LOCALE,
    payload: {
        id: id,
        value: value
    }
});

export const deleteCircuitPicture = (index: number): CircuitActionTypes => ({
    type: DELETE_CIRCUIT_PICTURE,
    payload: index
});
export const toggleCircuitPicturesOrder = (): CircuitActionTypes => ({
    type: TOGGLE_CIRCUIT_PICTURES_ORDER
});
export const toggleCircuitBannersOrder = (): CircuitActionTypes => ({
    type: TOGGLE_CIRCUIT_BANNERS_ORDER
});

export const updateCircuitPictureOrder = (drag_index: number, hover_index: number): CircuitActionTypes => ({
    type: UPDATE_CIRCUIT_PICTURE_ORDER,
    payload: {
        drag_index: drag_index,
        hover_index: hover_index
    }
});

export const setEdit = (
    step: null |
        'INFO' |
        'COMPLEMENTARY_INFO' |
        'PICTURES' |
        'PICTURES_ORDER' |
        'BANNERS' |
        'BANNERS_ORDER' |
        'SALE_PITCH' |
        'VERSIONS' |
        'DESCRIPTION' |
        'KEYWORDS' |
        'STRENGTHS' |
        'CHILD_REDUCTIONS' |
        'EXTRA' |
        'ADVANTAGES' |
        'USEFULL_LINKS' |
        'SEO' |
        'VIDEO' | 'INCLUDED_IN_PRICE' | 'PRICE_CONDITIONS' |
        'PROVIDER' | 'FILES' |
        'CMS'
): CircuitActionTypes => ({
    type: SET_EDIT,
    payload: step
});

export const setErrors = (errors: Error[]): CircuitActionTypes => ({
    type: SET_ERRORS,
    payload: errors
});

export const updateContractSelected = (contract: null | Contract): CircuitActionTypes => ({
    type: UPDATE_CONTRACT_SELECTED,
    payload: contract
});

export const updateSelectedCircuit = (circuits: Circuit[]): CircuitActionTypes => ({
    type: UPDATE_SELECTED_CIRCUIT,
    payload: circuits
});

export const updateManyCircuitVisibility = (circuits_id: number[], visibility: 'PUBLIC' | 'PRIVATE_TO' | 'PRIVATE'): CircuitActionTypes => ({
    type: UPDATE_MANY_CIRCUIT_VISIBILITY,
    payload: {
        circuits_id,
        visibility
    }
});

export const updateFilterLanguages = (languages: Language[]): CircuitActionTypes => ({
    type: UPDATE_FILTER_LANGUAGES,
    payload: languages
});
export const setColumns = (columns: Column[]): CircuitActionTypes => ({
    type: SET_COLUMNS,
    payload: columns
});

export const setIsProtectedDescription = (value: boolean): CircuitActionTypes => ({
    type: SET_IS_PROTECTED_DESCRIPTION,
    payload: value
});
